<template lang="">
    <v-container fluid fill-height>
        <!-- <v-card width="100vw"> -->
            <v-row>
                <v-col md="11">
                    {{titulo}}
                </v-col>
                <v-col md="1">
                    <hmi-editable-number-input 
                        :valor="getValue(topic)" 
                        :topic=topic
                        unidades="%"
                        @cambio="escribir"
                    />
                </v-col>
            </v-row>
        <!-- </v-card> -->
    </v-container>
        
    </div>
</template>
<script>
    import HmiEditableNumberInput from '@/components/HMI/modulos/HmiEditableNumberInput.vue'
import { mapActions } from 'vuex'
export default {
    components:{
        HmiEditableNumberInput
    },
    props:{
        datos:Object,
        valor:String,
        unidades:String,
        topic:String,
        titulo:String
    },

    methods: {
        ...mapActions("nodered",['doPublish']),
        getValue(nombre){
            if(nombre){
                return this.datos[nombre]
            }else return '?'
        },

        //Escribir en MQTT
        escribir(payload){
            const publication={
              topic:payload.topic,
              qos:2,
              payload:JSON.stringify({'valor':payload.valor}) ,
            }
            this.doPublish(publication)
            this.guardarModificacionBBDD(payload.topic, payload.valor)
        },
        async guardarModificacionBBDD(columna, valor){

            const item = {
                nombre_columna: columna,
                id_usuario: localStorage.getItem('id_usuario'),
                valor: valor,
            }

            await this.axios.post(`/post-hmi-modificacion/`, item).then(respuesta => {
                console.log('Valor hmi modificado correctamente');
            })
        },
    },
}
</script>
<style lang="">
    
</style>